import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { Grid, Paper, Typography, withStyles } from "@material-ui/core";
import styles from "../../../wrappers/admin/Admin.Styles";
import * as AccountHierarchyActions from "../../../store/AccountHierarchy";
import * as SnackbarActions from "../../../store/SnackbarStore";
import * as StrategyActions from "../../../store/StrategyStore";
import { userInRoles, UserRoleTypeEnum } from "../../../services/authService";
import HierarchyManager from "../../../components/HierarchyManager";
import Hierarchy, { HierarchyMode } from "../../../components/Hierarchy";
import DragSourceList, {
  DragSourceListMode
} from "../../../components/DragSourceList";
import { dndType } from "../../../components/DragSourceList";
import differenceWith from "lodash/differenceWith";

class StrategyApp extends Component {
  hierarchyType = "Strategy";
  hierarchyTypeId = 4;

  componentWillReceiveProps(nextProps) {
    const { strategies, hierarchyElements } = nextProps;
    this.setState({ strategies });
    this.setState({
      strategies: differenceWith(
        strategies,
        hierarchyElements,
        (a, h) => a.id === h.entityId
      )
    });
  }

  componentDidMount() {
    const { requestHierarchies, requestStrategies } = this.props;
    requestHierarchies(this.hierarchyType);
    requestStrategies();
  }

  state = {
    hierarchyId: 0,
    strategies: []
  };

  hierarchyChange = hierarchyId => {
    this.setState({ hierarchyId: Number(hierarchyId) });
  };

  hierarchyModified = ({ hierarchyId }) => {
    const { requestHierarchies } = this.props;
    requestHierarchies(this.hierarchyType);
  };

  hierarchyDeleted = ({ hierarchyId }) => {
    const { requestHierarchies } = this.props;
    this.hierarchyChange(0);
    requestHierarchies(this.hierarchyType);
  };

  render() {
    const { classes, hierarchies, user } = this.props;

    let hierarchyMode = userInRoles(user, [UserRoleTypeEnum.Administrator])
      ? HierarchyMode.EDIT
      : HierarchyMode.READ;
    let dragSourceListMode = userInRoles(user, [UserRoleTypeEnum.Administrator])
      ? DragSourceListMode.EDIT
      : DragSourceListMode.READ;

    return (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          Strategy Hierarchy
        </Typography>

        <HierarchyManager
          hierarchies={hierarchies}
          hierarchyChange={this.hierarchyChange}
          hierarchyDeleted={this.hierarchyDeleted}
          hierarchyAdded={this.hierarchyModified}
          hierarchyUpdated={this.hierarchyModified}
          hierarchyTypeId={this.hierarchyTypeId}
        />

        {this.state.hierarchyId > 0 ? (
          <div className={classes.root}>
            <Grid container spacing={8}>
              <Grid item xs={6}>
                <Paper className={classes.paper} style={{ maxHeight: 600 }}>
                  <Hierarchy
                    dndType={dndType}
                    hierarchyId={this.state.hierarchyId}
                    hierarchyTypeId={this.hierarchyTypeId}
                    hierarchyMode={hierarchyMode}
                  />
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper className={classes.paper} style={{ maxHeight: 600 }}>
                  <DragSourceList
                    accounts={this.state.strategies}
                    dragSourceListMode={dragSourceListMode}
                  />
                </Paper>
              </Grid>
            </Grid>
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hierarchies: state.accountHierarchy.hierarchies
      ? state.accountHierarchy.hierarchies
      : [],
    strategies: state.strategies.strategies ? state.strategies.strategies : [],
    hierarchyElements: state.accountHierarchy.hierarchyElements || [],
    user: state.user.user
  };
}

export default connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        AccountHierarchyActions.actionCreators,
        StrategyActions.actionCreators,
        SnackbarActions.actionCreators
      ),
      dispatch
    )
)(withStyles(styles)(DragDropContext(HTML5Backend)(StrategyApp)));
